import { Card, CardBody, CardHeader } from "../../components/card/card.jsx";
import { Spinner } from "react-bootstrap";
function SpinnerSection({ title = "no title" }) {
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">{title}</CardHeader>
        <CardBody className="card-body pb-2">
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="primary" />
          </div>
        </CardBody>
      </Card>
    </>
  );
}

export default SpinnerSection;
